import styled from "styled-components";

export const FooterWrapper = styled.footer`
  margin-top: 200px;
  padding: 4em 0 2em 0;
  background-color: #edf3f6;
  box-shadow: 1px 1px 12px 5px rgba(0, 0, 0, 0.1);
`;

export const FooterText = styled.p`
  margin: 0 auto 1em auto;
  max-width: 50%;
  text-align: center;
  font-weight: 600;
  font-size: 1.1em;

  @media (max-width: 768px) {
    max-width: 90%;
  }
`;

export const FooterLinks = styled.div``;
